import { GetStaticProps, NextPage } from 'next';
import React from 'react';
import { useIntl } from 'react-intl';

import HeadMeta from '@/components/static-pages/HeadMeta';
import AffiliateTemplate from '@/components/templates/AffiliateTemplate';
import { getStaticPageData } from '@/services/getPageData';
import { isEmptyResponse } from '@/utility/isEmptyResponse';

interface IProps {
  heroHeading: string;
  heroImage: string;
  title: string;
  description: string;
  url: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contentBlocks: { type: string; value: any }[];
  noindex: boolean;
}

const Affiliate: NextPage<IProps> = props => {
  const { title, description, url, heroHeading, heroImage, contentBlocks, noindex } = props;
  const intl = useIntl();
  const defaultTitle = intl.formatMessage({
    defaultMessage: 'The Marketplace For RV Sharing',
    id: 'zKQ83d',
  });
  const defaultDescription = intl.formatMessage({
    defaultMessage:
      'Find RV Rentals Near you on Outdoorsy. The only person-to-person RV rental marketplace in the US',
    id: 'qz1auY',
  });

  const metaTitle = title ?? defaultTitle;
  const metaDescription = description ?? defaultDescription;
  return (
    <>
      <HeadMeta title={metaTitle} description={metaDescription} url={url} noindex={noindex} />
      <AffiliateTemplate
        heroHeading={heroHeading}
        heroImage={heroImage}
        contentBlocks={contentBlocks}
      />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const pageData = await getStaticPageData({ locale, url_path: 'affiliate' });
  if (isEmptyResponse(pageData) || isEmptyResponse(pageData.metadata)) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const { heading, hero_image, seo_title, seo_description, url, content_blocks } =
    pageData.metadata;

  return {
    props: {
      heroHeading: heading,
      heroImage: hero_image,
      title: seo_title,
      description: seo_description,
      url,
      contentBlocks: content_blocks,
      noindex: !!pageData.fallback,
    },

    revalidate: 20,
  };
};

export default Affiliate;
